// Same approach as bundle-color-picker.js, for a bundle of two independent
// items instead of one shared model: each pair (model + color) only ever
// writes a value into its own real <option> that already exists in the
// matching real Simple Bundles select, then fires a real 'change' event.
// Never recomputes or guesses a variant/property value itself.
(function(){
  var MODELS = ['15', '15 Pro', '15 Pro Max', '16', '16 Pro', '16 Pro Max', '17', '17 Pro', '17 Pro Max'];

  function init(){
    var picker = document.getElementById('bundle-skin-pair-picker');
    var model1Sel = document.getElementById('bp2-model1');
    var color1Sel = document.getElementById('bp2-color1');
    var model2Sel = document.getElementById('bp2-model2');
    var color2Sel = document.getElementById('bp2-color2');
    var msgEl = document.getElementById('bp2-msg');
    if (!picker || !model1Sel || !color1Sel || !model2Sel || !color2Sel || !msgEl) return;

    var tries = 0;
    (function waitForApp(){
      var appWrap = document.getElementById('simple-bundles-io-options');
      var realSelects = appWrap ? appWrap.querySelectorAll('select') : [];
      if (appWrap && realSelects.length >= 2) {
        start(appWrap, realSelects[0], realSelects[1]);
        return;
      }
      tries++;
      if (tries > 40) { // ~6s at 150ms
        msgEl.hidden = false;
        msgEl.textContent = 'Selectorul nu s-a putut încărca. Reîmprospătează pagina.';
        return;
      }
      setTimeout(waitForApp, 150);
    })();
  }

  function start(appWrap, realSkin1, realSkin2){
    var model1Sel = document.getElementById('bp2-model1');
    var color1Sel = document.getElementById('bp2-color1');
    var model2Sel = document.getElementById('bp2-model2');
    var color2Sel = document.getElementById('bp2-color2');
    var msgEl = document.getElementById('bp2-msg');

    appWrap.style.display = 'none';

    function parseOptions(select){
      var data = {};
      var colors = [];
      Array.prototype.forEach.call(select.options, function(opt){
        if (!opt.value) return;
        var parts = opt.value.split(' / iPhone ');
        if (parts.length !== 2) return;
        var color = parts[0], model = parts[1];
        if (!data[color]) { data[color] = {}; colors.push(color); }
        data[color][model] = {
          value: opt.value,
          inventory: parseInt(opt.getAttribute('data-inventory'), 10) || 0
        };
      });
      return { data: data, colors: colors };
    }

    function fillSelect(sel, items){
      sel.innerHTML = '';
      items.forEach(function(it){
        var opt = document.createElement('option');
        opt.value = it.value;
        opt.textContent = it.label;
        if (it.disabled) opt.disabled = true;
        sel.appendChild(opt);
      });
    }

    function refreshColorSelect(sel, info, selectedModel){
      var prevValue = sel.value;
      var items = [{ value: '', label: selectedModel ? 'Alege culoarea' : 'Alege mai întâi modelul' }];
      info.colors.forEach(function(color){
        var entry = selectedModel ? info.data[color][selectedModel] : null;
        var outOfStock = !!selectedModel && (!entry || entry.inventory <= 0);
        items.push({
          value: color,
          label: color + (outOfStock ? ' — Indisponibil' : ''),
          disabled: outOfStock
        });
      });
      fillSelect(sel, items);
      sel.disabled = !selectedModel;
      if (selectedModel && prevValue){
        var stillOk = info.data[prevValue] && info.data[prevValue][selectedModel] && info.data[prevValue][selectedModel].inventory > 0;
        sel.value = stillOk ? prevValue : '';
      }
    }

    function setRealSelect(realSel, value){
      if (realSel.value === value) return;
      realSel.value = value;
      realSel.dispatchEvent(new Event('change', { bubbles: true }));
      realSel.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function findSubmitButton(){
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return null;
      return form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    }

    // Each pair is built as its own independent unit — a model select
    // feeding a color select — so the same logic can run twice.
    function makePair(modelSel, colorSel, realSel){
      var info = parseOptions(realSel);
      fillSelect(modelSel, [{ value: '', label: 'Alege modelul' }].concat(
        MODELS.map(function(m){ return { value: m, label: 'iPhone ' + m }; })
      ));
      modelSel.disabled = false;

      function currentEntry(){
        var model = modelSel.value, color = colorSel.value;
        return (model && color) ? info.data[color][model] : null;
      }

      function refresh(){
        refreshColorSelect(colorSel, info, modelSel.value);
      }

      modelSel.addEventListener('change', function(){ refresh(); evaluate(); });
      colorSel.addEventListener('change', evaluate);

      return { refresh: refresh, currentEntry: currentEntry, realSel: realSel };
    }

    var pair1 = makePair(model1Sel, color1Sel, realSkin1);
    var pair2 = makePair(model2Sel, color2Sel, realSkin2);

    function evaluate(){
      var entry1 = pair1.currentEntry();
      var entry2 = pair2.currentEntry();
      var valid = !!(entry1 && entry1.inventory > 0 && entry2 && entry2.inventory > 0);
      var btn = findSubmitButton();

      if (valid){
        setRealSelect(pair1.realSel, entry1.value);
        setRealSelect(pair2.realSel, entry2.value);
        msgEl.hidden = true;
        if (btn) btn.disabled = false;
      } else {
        if (btn) btn.disabled = true;
        msgEl.hidden = false;
        if (!model1Sel.value || !model2Sel.value) {
          msgEl.textContent = 'Alege modelul pentru fiecare skin în parte.';
        } else if (!color1Sel.value || !color2Sel.value) {
          msgEl.textContent = 'Alege culoarea pentru fiecare skin în parte.';
        } else {
          msgEl.textContent = 'Una din combinațiile alese nu mai e în stoc. Alege altă culoare.';
        }
      }
    }

    var initialBtn = findSubmitButton();
    if (initialBtn) initialBtn.disabled = true;

    evaluate();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
